import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDeleteFileState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DeleteFileEmptyState: IDeleteFileState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
